import { addErrorHandler, start as startSingleSpa } from "single-spa";
import { initAnalytics } from "../analytics";
import { initApps, initCACheckApp, initConstantApps, initCryptoApiTestApp, initCSIForm, initLEQ, initSupportChat, } from "./init-apps";
import { hideLoader } from "./ui.helpers";
import { enableErrorHandler } from "./error.helpers";
import { addEventListeners, addIncapsulatedAppsWatcher, addTitleChangeListener, } from "./event-listeners.helpers";
import { getInitialData, getDataFromStrapi } from "./initial-data";
import { setLocaleListeners } from "./locale.helpers";
let applicationsList = {};
export async function start(context) {
    setLocaleListeners(context, context.locale);
    let menuData = {
        menus: [],
        cabinets: [],
        aside: [],
        products: [],
    };
    if (context.auth && context.auth.user) {
        const { applications, menu } = await getInitialData(context);
        const { incapsulatedAppsCodes, ...data } = await getDataFromStrapi(context, context.locale.locale);
        incapsulatedAppsCodes;
        const ctx = {
            ...context,
            ...data,
        };
        applicationsList = applications;
        initApps(applications, ctx);
        initSupportChat(applications, ctx);
        initLEQ(applications, ctx);
        initCSIForm(applications, ctx);
        initConstantApps(menu, ctx);
        initAnalytics(ctx);
        menuData = {
            menus: ctx.menus,
            cabinets: ctx.cabinetLinks,
            aside: data.asideMenus || [],
            products: data.products || [],
        };
        addIncapsulatedAppsWatcher(incapsulatedAppsCodes ?? []);
    }
    else {
        initConstantApps({}, context);
    }
    initCryptoApiTestApp(context);
    initCACheckApp(context);
    startSingleSpa();
    hideLoader();
    addErrorHandler((err) => {
        enableErrorHandler(err);
    });
    addEventListeners(applicationsList, menuData);
    addTitleChangeListener();
}
